<script lang="ts">
	//Stores
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';
	//Helpers
	import { checkIsComponent } from '../sidepanel-helpers';
	//Components
	import SidePanelSceneLayout from './SidePanelSceneLayout/SidePanelSceneLayout.svelte';
	import SidePanelGroupLayout from './SidePanelGroupLayout/SidePanelGroupLayout.svelte';
	import SidePanelRoomLayout from './SidePanelRoomLayout/SidePanelRoomLayout.svelte';
	import SidePanelAlarmLayout from './SidePanelAlarmLayout/SidePanelAlarmLayout.svelte';
	import SidePanelDashLayout from './SidePanelDashLayout/SidePanelDashLayout.svelte';
	import SidePanelDeviceLayoutProvider from './SidePanelDeviceLayout/SidePanelDeviceLayoutProvider.svelte';
	import SidePanelThermostatLayout from './SidePanelThermostatLayout/SidePanelThermostatLayout.svelte';

	const sidePanelLayout = {
		scenes: SidePanelSceneLayout,
		scene: SidePanelSceneLayout,
		group: SidePanelGroupLayout,
		groups: SidePanelGroupLayout,
		device: SidePanelDeviceLayoutProvider,
		devices: SidePanelDeviceLayoutProvider,
		room: SidePanelRoomLayout,
		rooms: SidePanelRoomLayout,
		alarm: SidePanelAlarmLayout,
		alarms: SidePanelAlarmLayout,
		dash: SidePanelDashLayout,
		dashboard: SidePanelDashLayout,
		thermostat: SidePanelThermostatLayout,
		thermostats: SidePanelThermostatLayout,
	};
</script>

{#key $sidePanelState.id}
	<svelte:component this={checkIsComponent(sidePanelLayout[$sidePanelState.type])} on:close />
{/key}
